<template>
  <div class="tasks queue">
    <div class="tasks-header">
      <div class="title">
        {{ successes }} / {{ tasks.length }} 个任务执行成功
      </div>
      <div class="operation">
        <a :class="[expand ? '' : 'act']" @click="toggleExpand"
          ><i class="ti-angle-down"></i
        ></a>
        <a class="close" @click="close"><i class="iconfont icon-close"></i></a>
      </div>
    </div>
    <div class="tasks-body" v-show="expand">
      <div class="tasks-item" v-for="(item, index) in tasks" :key="index">
        <div class="item-info">
          <p :title="item.message">
            {{ item.message }}
          </p>
        </div>
        <div class="item-speed">
          <span>{{
            stateMap[item.job_type] ? stateMap[item.job_type][item.state] : ""
          }}</span>
        </div>
        <div class="item-status">
          <a>
            <i
              class="iconfont icon-status-processing"
              v-if="item.state === 1 || item.state === 0"
            ></i>
            <i class="iconfont icon-status-succ" v-if="item.state === 2"></i>
            <i class="iconfont icon-status-fail" v-if="item.state === 3"></i>
          </a>
        </div>
        <div
          class="progress"
          :style="'width: ' + item.run_percent + '%;'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import { getCopyJobProgress } from "@/api/drive/drive";
export default {
  name: "GlobalQueue",
  data() {
    return {
      successes: 0,
      expand: true,
      stateMap: {
        0: {
          0: "排队中",
          1: "复制中",
          2: "复制成功",
          3: "复制失败",
        },
        1: {
          0: "排队中",
          1: "保存中",
          2: "保存成功",
          3: "保存失败",
        },
        2: {
          0: "排队中",
          1: "保存中",
          2: "保存成功",
          3: "保存失败",
        },
      },
    };
  },
  computed: {
    tasks() {
      return this.$store.state.drive.tasks;
    },
  },
  methods: {
    toggleExpand() {
      this.expand = !this.expand;
    },
    close() {
      this.panelShow = false;
      // 触发关闭组件
      Bus.$emit("changeGlobalPluginStatus", {
        plugin: "showGlobalQueue",
        status: false,
      });
      // this.$store.commit("changeTasks", []);
    },
    changeStatus(task, res) {
      this.$store.commit("changeTask", {
        task: task,
        state: res.state,
        job_type: res.job_type,
        run_percent: res.run_percent,
        message: res.message,
      });
    },
    async handleJob(task) {
      let res = await this.getCopyJobProgress(task.job_id);
      if (res.status_code === 5001) {
        this.changeStatus(task, {
          state: 3,
          run_percent: 0,
          job_type: res.entity.job_type,
          message: res.message,
        });
        // 出现错误后不继续轮询
        // setTimeout(() => {
        //   this.handleJob(task);
        // }, 2000);
      } else if (res.status_code === 200) {
        if (res.entity.state === 0) {
          this.changeStatus(task, res.entity);
          // 未执行
          setTimeout(() => {
            this.handleJob(task);
          }, 2000);
        } else if (res.entity.state === 1) {
          this.changeStatus(task, res.entity);
          // 执行中
          setTimeout(() => {
            this.handleJob(task);
          }, 2000);
        } else if (res.entity.state === 2) {
          this.successes++;
          this.changeStatus(task, res.entity);
          // 执行成功后
          Bus.$emit("jobSuccess");
        } else if (res.entity.state === 3) {
          this.changeStatus(task, res.entity);
        }
      } else {
        this.changeStatus(task, {
          state: 3,
          run_percent: 0,
          job_type: res.entity.job_type,
          message: res.message,
        });
      }
    },
    async getCopyJobProgress(job_id) {
      return await getCopyJobProgress({
        job_id: job_id,
      })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  watch: {
    tasks(newValue) {
      // console.log(newValue.length, oldValue.length)
      if (newValue.length) {
        this.handleJob(newValue[newValue.length - 1]);
      }
    },
  },
};
</script>

<style scope>
.queue .tasks-item .item-info {
  width: 325px;
}
.queue .tasks-item .item-info {
  padding-left: 0;
}
.queue .tasks-item .item-icon {
  font-size: 12px;
  color: #383838;
}
.queue .tasks-item .progress {
  height: 59px;
  position: absolute;
  bottom: -20px;
  background-color: rgba(150, 208, 150, 0.3);
  box-shadow: none;
  left: 0;
  border-radius: 0;
  z-index: 1;
}
</style>